
export default function HeroSection() {
  const scrollToReservar = () => {
    const element = document.getElementById('reservar');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPortfolio = () => {
    const element = document.getElementById('portfolio');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden py-20">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url("https://public.readdy.ai/ai/img_res/578cd3a437d27d5369596c864bd05639.jpg")'
        }}
      ></div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="absolute top-4 left-4 right-4">
        <div className="flex gap-2">
          <div className="w-16 h-0.5 bg-white/60"></div>
          <div className="w-16 h-0.5 bg-white/60"></div>
        </div>
      </div>

      <div className="absolute bottom-4 right-4">
        <div className="flex flex-col gap-2 items-end">
          <div className="w-16 h-0.5 bg-white/60"></div>
          <div className="w-16 h-0.5 bg-white/60"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 w-full">
        <div className="flex flex-col items-center text-center">
          <div className="w-28 h-28 md:w-48 md:h-48 mb-6 md:mb-10 rounded-full overflow-hidden shadow-2xl shadow-black/50 border-4 border-white/20">
            <img 
              src="https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/b77abd256c0fcd5d12b7048a94ca1456.jpeg" 
              alt="Daro Tattoo Logo" 
              className="w-full h-full object-cover"
            />
          </div>

          <div className="inline-block border border-white/80 px-4 md:px-6 py-2 md:py-3 mb-6 md:mb-8">
            <span className="text-white text-xs md:text-sm font-medium tracking-widest uppercase">
              Estudio Profesional en Adra
            </span>
          </div>

          <h1 
            className="text-[48px] sm:text-[72px] md:text-[100px] lg:text-[140px] leading-none font-bold text-white mb-4 md:mb-8"
            style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '4px' }}
          >
            ARTE EN TU PIEL<br />
            DARO TATTOO
          </h1>

          <p className="text-neutral-200 text-base md:text-xl font-light mb-8 md:mb-12 max-w-2xl px-4">
            Tatuajes personalizados con más de 10 años de experiencia en Black & Grey y realismo
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 w-full sm:w-auto px-4 sm:px-0">
            <button 
              onClick={scrollToReservar}
              className="px-8 md:px-10 py-4 md:py-5 bg-black text-white font-medium hover:bg-neutral-800 transition-all cursor-pointer whitespace-nowrap text-sm md:text-base"
              style={{ clipPath: 'polygon(12px 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%, 0 12px)' }}
            >
              <i className="ri-calendar-line mr-2"></i>
              RESERVAR AHORA
            </button>

            <button 
              onClick={scrollToPortfolio}
              className="px-8 md:px-10 py-4 md:py-5 bg-transparent border-2 border-white/80 text-white font-medium hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-sm md:text-base"
              style={{ clipPath: 'polygon(12px 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%, 0 12px)' }}
            >
              VER TRABAJOS
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
